export const homeCareStore = (state: any) => Object.assign({}, state.homeCare, { contactInfo: state.contactInfo, auth: state.auth });
